import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all state values
export const GET_COMMISSION_LIST = "GET_COMMISSION_LIST";
export const GET_SOGANDHNAMU_DETAILS = "GET_SOGANDHNAMU_DETAILS";
export const GENERATE_TRANSPORTATION_CERTIFICATE = "GENERATE_TRANSPORTATION_CERTIFICATE";
export const MARK_COMMISSION_AS_PAID = "MARK_COMMISSION_AS_PAID";
export const COMMISSION_DETAILS = "COMMISSION_DETAILS";
export const STUDENT_ATTENDANCE = "STUDENT_ATTENDANCE";
export const GET_COMMISSION_MONTH_LIST = "GET_COMMISSION_MONTH_LIST";
export const GET_COMMISSION_SORT_LIST = "GET_COMMISSION_SORT_LIST";
export const RESET_COMMISSION_DATA = 'RESET_COMMISSION_DATA';

export const getCommissionList = (page, rowsPerPage, data) => (dispatch) => { // get commission list api calling
  axios.post(`/commission?page=${page}&size=${rowsPerPage}`, data).then((res) => {
    dispatch({
      type: GET_COMMISSION_LIST,
      payload: res.data,
    });
  });
};

export const getSogandhnamuDetails = (Id) => (dispatch) => { // get sogandhnamu details api call
  axios.get(`/commission/${Id}/certificate`).then((res) => {
    dispatch({
      type: GET_SOGANDHNAMU_DETAILS,
      payload: res.data,
    });
  });
};

export const generateTransportationCertificate = (Id,data) => (dispatch) => {// create transportation allowance certificate api
  axios
    .post(`commission/${Id}/commission/create`, data,
    // .post(`/commission/transportationcertificate/${Id}/create`, data,
    {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: GENERATE_TRANSPORTATION_CERTIFICATE,
        payload: response.data,
      });
      dispatch(getCommissionList(1,10))
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const markCommissionAsPaid = (id,data) => (dispatch) => { // mark commission paid api call
  axios
    .post(`/commission/${id}/mark/paid`, data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: MARK_COMMISSION_AS_PAID,
        payload: response.data,
      });
      dispatch(getCommissionList(1,10))
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getCommissionDetails = (id) => (dispatch) => { 
  axios
    .get(`/commission/${id}/details`)
    .then((response) => {
      dispatch({
        type: COMMISSION_DETAILS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getStudentAttendances = (id) => (dispatch) => { 
  axios
    .get(`/trip_commission/${id}/attendance_chart`)
    .then((response) => {
      dispatch({
        type: STUDENT_ATTENDANCE,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getCommissionMonthList = (month, data, id, year) => (dispatch) => { // get commission Month list api calling
  axios.get(`/commission/month/${month}`, {
    headers: {
      filter_type: data,
      filter_code: id,
      academic_year: year
    }
  }).then((res) => {
    dispatch({
      type: GET_COMMISSION_MONTH_LIST,
      payload: res.data,
    });
  });
};

export const getCommissionSort = (page, size, month, sort, type, code, data) => (dispatch) => { // get commission sort list api calling
  axios.post(`commission/drivers?page=${page}&size=${size}&month=${month}&sort=${sort}`,data, {
    headers: {
      filter_type: type,
      filter_code: code,
    }
  }).then((res) => {
    dispatch({
      type: GET_COMMISSION_SORT_LIST,
      payload: res.data,
    });
  });
};

export const resetCommissionDataData = () => ({
  type: RESET_COMMISSION_DATA,
});